import React, {PropsWithChildren, useEffect} from "react";
import {useNavigate} from "react-router";

export const HOCNavigate: React.FC<PropsWithChildren> = ({children}) => {
	const navigate = useNavigate();

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const groupId = params.get("groupId");

		if (groupId) {
			navigate(`/groups/join/${groupId}`);
		}
	}, [navigate]);

	return <React.Fragment>{children}</React.Fragment>;
};
